export enum Gender {
  Male = '1',
  Female = '2',
  Other = '3',
}
